import React from "react";
import { Helmet } from "react-helmet";
import { CheckCircleOutlined } from "@ant-design/icons";
import { Result } from "antd";

interface ICAProps {
  ca?: string;
  title: string;
  subTitle: string;
  icon?: boolean;
}

const ResultPage: React.FC<ICAProps> = ({
  ca,
  title,
  subTitle,
  icon = true,
}) => {
  return (
    <div className="selected-ca-page">
      <Helmet>
        <title>{ca ? `${ca} - ` : ""}Mercury © RWS</title>
      </Helmet>
      <Result
        title={title}
        icon={
          icon ? (
            <CheckCircleOutlined
              style={{ fontSize: "48px", color: "var(--tertiary-color)" }}
            />
          ) : (
            <></>
          )
        }
        subTitle={subTitle}
      />
    </div>
  );
};

export default ResultPage;
